<div class="form-container">
  <div class="form-header">
    <div class="header-icon">
      <i class="pi pi-calendar"></i>
    </div>
    <h2 class="header-title">{{inEditMode ? 'Edit Event' : cloneEvent ? 'Clone Event' : 'Create New Event'}}</h2>
  </div>

  <div class="form-content">
    <form [formGroup]="addEventForm" (ngSubmit)="onPublish()">
      
      <div class="form-section">
        <div class="form-group neo-input-wrapper">
          <label class="form-label">Event Title <span class="required">*</span></label>
          <input type="text" pInputText formControlName="eventTitle" class="form-input"
            [class.is-invalid]="clicked && addEventForm.controls['eventTitle'].errors"
            placeholder="Enter event title" id="add-event-title">
          <app-handle-error [clicked]="clicked" [control]="addEventForm.get('eventTitle')" name="Event title">
          </app-handle-error>
        </div>

        <div class="form-group neo-input-wrapper">
          <label class="form-label">Job Role <span class="required">*</span></label>
          <div class="dropdown-wrapper">
            <div class="input-with-spinner">
              <p-multiselect
              [options]="jobRoles"
              formControlName="jobRole"
              optionLabel="name"
              optionValue="id"
              placeholder="Select Job Roles"
              display="chip"
              [filter]="true"
              [showClear]="true"
              inputId="add-event-job-role"
              class="form-multiselect job-role-multiselect"
              #jobRole
              [panelStyle]="{
                  'min-width': jobRole.el.nativeElement.offsetWidth + 'px',
                  'max-width': jobRole.el.nativeElement.offsetWidth + 'px'
              }">
              <ng-template let-job pTemplate="item">
                <div class="job-role-dropdown-item">
                  <div class="job-role-details">
                    <span>
                      <span class="job-role-title">{{ job.name }}</span>
                      <span class="job-role-type" style="margin-left: 0.5rem;">
                        {{ job.role_type_name }}
                      </span>
                    </span>                    
                    <span class="job-role-meta">
                      <span class="job-role-poster">
                        {{ job.created_by_first_name }} {{ job.created_by_last_name }}
                      </span>
                      <span class="job-role-posted">
                        {{ getPostedAgo(job.created_at) }}
                      </span>
                    </span>
                  </div>
                </div>
              </ng-template>              
            </p-multiselect>            
            </div>
          </div>
          <app-handle-error [clicked]="clicked" [control]="addEventForm.get('jobRole')" name="Job role">
          </app-handle-error>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Event Start Date <span class="required">*</span></label>
            <p-datepicker formControlName="eventStartDate" [readonlyInput]="true" 
              dateFormat="m/d/y," dataType="date" iconDisplay="input"
              [minDate]="!inEditMode ? currentDate : null" [maxDate]="addEventForm.get('eventEndDate')?.value"
              [showIcon]="true" [showTime]="true" [hourFormat]="'12'"
              (onSelect)="resetRegistrationDates()"
              [styleClass]="clicked && addEventForm.controls['eventStartDate'].errors ? 'error' : ''"
              inputId="add-event-start-date" appendTo="body" [panelStyleClass]="'filter-date-range'"
              class="form-calendar eventStartDate">
            </p-datepicker>
            <app-handle-error [clicked]="clicked" [control]="addEventForm.get('eventStartDate')" name="Event start date">
            </app-handle-error>
          </div>

          <div class="form-group">
            <label class="form-label">Event End Date <span class="required">*</span></label>
            <p-datepicker formControlName="eventEndDate" [readonlyInput]="true" 
              dateFormat="m/d/y," dataType="date" iconDisplay="input"
              [minDate]="addEventForm.get('eventStartDate')?.value ?? currentDate"
              [showIcon]="true" [showTime]="true" [hourFormat]="'12'"
              (onSelect)="resetRegistrationDates()"
              inputId="add-event-end-date" appendTo="body" [panelStyleClass]="'filter-date-range'"
              [styleClass]="clicked && addEventForm.controls['eventEndDate'].errors ? 'error' : ''"
              class="form-calendar eventEndDate">
            </p-datepicker>
            <app-handle-error [clicked]="clicked" [control]="addEventForm.get('eventEndDate')" name="Event end date">
            </app-handle-error>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Registration Start Date <span class="required">*</span></label>
            <p-datepicker formControlName="registrationStartDate" [readonlyInput]="true" 
              dateFormat="m/d/y," dataType="date" [minDate]="!inEditMode ? currentDate : null"
              [maxDate]="addEventForm.get('registrationEndDate')?.value ?? addEventForm.get('eventEndDate')?.value"
              [showTime]="true" [hourFormat]="'12'" [showIcon]="true" iconDisplay="input"
              inputId="add-event-reg-start-date" appendTo="body" [panelStyleClass]="'filter-date-range'"
              [styleClass]="clicked && addEventForm.controls['registrationStartDate'].errors ? 'error' : ''"
              class="form-calendar registrationStartDate">
            </p-datepicker>
            <app-handle-error [clicked]="clicked" [control]="addEventForm.get('registrationStartDate')"
              name="Registration start date"></app-handle-error>
          </div>

          <div class="form-group">
            <label class="form-label">Registration End Date <span class="required">*</span></label>
            <p-datepicker formControlName="registrationEndDate" [readonlyInput]="true"
              dateFormat="m/d/y," dataType="date" iconDisplay="input"
              [minDate]="addEventForm.get('registrationStartDate')?.value"
              [maxDate]="addEventForm.get('eventEndDate')?.value"
              [showIcon]="true" [showTime]="true" [hourFormat]="'12'"
              inputId="add-event-reg-end-date" appendTo="body" [panelStyleClass]="'filter-date-range'"
              [styleClass]="clicked && addEventForm.controls['registrationEndDate'].errors ? 'error' : ''"
              class="form-calendar registrationEndDate">
            </p-datepicker>
            <app-handle-error [clicked]="clicked" [control]="addEventForm.get('registrationEndDate')"
              name="Registration end date"></app-handle-error>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group neo-input-wrapper">
            <label class="form-label">Event Category <span class="required">*</span></label>
            <div class="dropdown-wrapper">
              <p-select big optionLabel="name"
                inputId="add-event-event-category"
                optionValue="id" formControlName="eventCategory" [required]="true" [options]="eventCategories" [filter]="true" [filterBy]="'name'"
                [styleClass]="clicked && addEventForm.controls['eventCategory'].errors ? 'error' : ''"
                class="form-dropdown event-category">
              </p-select>
            </div>
            <app-handle-error [clicked]="clicked" [control]="addEventForm.get('eventCategory')" name="Event Category">
            </app-handle-error>
          </div>

          <div class="form-group">
            <label class="form-label">Work Experience</label>
            <div class="input-group">
              <p-inputNumber inputId="add-event-work-experience" formControlName="workExperience" class="form-input-number"
                [class.error]="clicked && addEventForm.controls['workExperience'].errors">
              </p-inputNumber>
              <span class="input-addon">Years</span>
            </div>
            <div class="error-message" *ngIf="clicked && addEventForm.controls['workExperience'].errors?.['max']">
              Work Experience must be Less than or Equal to 50
            </div>
            <div class="error-message" *ngIf="clicked && addEventForm.controls['workExperience'].errors?.['min']">
              Valid Work Experience is required
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Minimum Salary/Annum</label>
            <div class="input-group">
              <span class="input-addon">₹</span>
              <p-inputNumber inputId="add-event-min-salary" type="number" formControlName="minSalary" [(ngModel)]="minSalary"
                class="form-input-number"
                [class.error]="clicked && addEventForm.controls['minSalary'].errors">
              </p-inputNumber>
            </div>
            <div class="error-message" *ngIf="clicked && addEventForm.controls['minSalary'].errors">
              Valid Minimum salary is required
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Maximum Salary/Annum</label>
            <div class="input-group">
              <span class="input-addon">₹</span>
              <p-inputNumber inputId="add-event-max-salary" type="number" formControlName="maxSalary" [(ngModel)]="maxSalary"
                class="form-input-number"
                [class.error]="(clicked && addEventForm.controls['maxSalary'].errors) || maxSalary < minSalary">
              </p-inputNumber>
            </div>
            <div class="error-message" *ngIf="clicked && addEventForm.controls['maxSalary'].errors">
              Valid Maximum salary is required
            </div>
          </div>
        </div>

        <div class="form-group neo-input-wrapper">
          <label class="form-label">Event Type <span class="required">*</span></label>
          <div class="dropdown-wrapper">
            <p-select big optionLabel="name"
              (onChange)="onEventTypeChange()" optionValue="id" formControlName="eventType" [required]="true"
              [options]="eventTypes" [filter]="true" [filterBy]="'name'"
              [styleClass]="clicked && addEventForm.controls['eventType'].errors ? 'error' : ''"
              inputId="add-event-event-type" appendTo="body"
              class="form-dropdown event-type">
            </p-select>
          </div>
          <app-handle-error [clicked]="clicked" [control]="addEventForm.get('eventType')" name="Event type">
          </app-handle-error>
        </div>

        <div class="form-group neo-input-wrapper" *ngIf="addEventForm.value.eventType">
          <label class="form-label">Institution Name 
            <span class="required" *ngIf="getSelectedEventType()?.institution_select_type !== 'not_applicable'">*</span>
          </label>
          <div class="dropdown-wrapper">
            <ng-container *ngIf="getSelectedEventType()?.institution_select_type !== 'single'; else singleSelect">
              <p-multiselect 
                big
                [options]="institutions" 
                formControlName="institutionName" 
                optionLabel="name"
                optionValue="id" 
                placeholder="Select Institutions"
                display="chip"
                [filter]="true" 
                [filterBy]="'name'"
                [showClear]="true"
                [required]="getSelectedEventType()?.institution_select_type !== 'not_applicable'"
                [styleClass]="clicked && addEventForm.controls['institutionName'].errors ? 'error' : ''"
                class="form-multiselect institution-name"
                inputId="add-event-institution-name"
                [overlayOptions]="{styleClass: 'overflow-auto'}"
                #institutionName appendTo="body"
                [virtualScroll]="true" [virtualScrollItemSize]="43"
                [panelStyle]="{
                    'min-width': institutionName.el.nativeElement.offsetWidth + 'px',
                    'max-width': institutionName.el.nativeElement.offsetWidth + 'px'
                }">
                <ng-template let-institution pTemplate="item">
                  <div [title]="institution.name">
                    {{ institution.name }}, {{ institution.city }}
                  </div>
                </ng-template>
              </p-multiselect>
            </ng-container>
            <ng-template #singleSelect>
              <p-select big optionLabel="name" optionValue="id" 
                formControlName="institutionName" [required]="true" [options]="institutions" 
                [filter]="true" [filterBy]="'name'"
                inputId="add-event-institution-name"
                [styleClass]="clicked && addEventForm.controls['institutionName'].errors ? 'error' : ''"
                class="form-dropdown institution-dropdown" #institutionNameSelect appendTo="body"
                [overlayOptions]="{styleClass: 'overflow-auto'}"
                [virtualScroll]="true" [virtualScrollItemSize]="43"
                [panelStyle]="{
                    'min-width': institutionNameSelect.el.nativeElement.offsetWidth + 'px',
                    'max-width': institutionNameSelect.el.nativeElement.offsetWidth + 'px'
                }">
                <ng-template let-institution pTemplate="item">
                  <span class="dropdown-item-content" [title]="institution.name" >
                    {{ institution.name }}, {{ institution.city }}
                  </span>
                </ng-template>
              </p-select>
            </ng-template>
          </div>
          <app-handle-error [clicked]="clicked" [control]="addEventForm.get('institutionName')" name="Institution name">
          </app-handle-error>
        </div>

        <div class="form-group neo-input-wrapper" *ngIf="addEventForm.value.eventType">
          <label class="form-label">Institution Address 
            <span class="required" *ngIf="getSelectedEventType()?.institution_select_type !== 'not_applicable'">*</span>
          </label>
          <input inputId="add-event-institution-address" type="text" pInputText formControlName="institutionAddress" class="form-input"
            [class.error]="clicked && addEventForm.controls['institutionAddress'].errors"
            placeholder="Enter institution address">
          <app-handle-error [clicked]="clicked" [control]="addEventForm.get('institutionAddress')"
            name="Institution address"></app-handle-error>
        </div>

        <div class="form-group neo-input-wrapper">
          <label class="form-label">Registration Form <span class="required">*</span></label>
          <div class="dropdown-wrapper">
            <p-select inputId="add-event-registration-form" big optionLabel="name" optionValue="uuid"
              formControlName="reg_form_uuid" [required]="true" [options]="regForms" [filter]="true" [filterBy]="'name'"
              [styleClass]="clicked && addEventForm.controls['reg_form_uuid'].errors ? 'error' : ''"
              class="form-dropdown reg_form_uuid" appendTo="body" #registrationSelectEl [panelStyle]="{
                'min-width': registrationSelectEl.el.nativeElement.offsetWidth + 'px',
                'max-width': registrationSelectEl.el.nativeElement.offsetWidth + 'px'
              }">
            </p-select>
          </div>
          <app-handle-error [clicked]="clicked" [control]="addEventForm.get('reg_form_uuid')" name="Registration form">
          </app-handle-error>
        </div>

        <div class="form-group neo-input-wrapper">
          <label class="form-label">Email Template <span class="required">*</span></label>
          <div class="dropdown-wrapper">
            <p-select inputId="add-event-email-template" big optionLabel="name" optionValue="id"
              formControlName="email_template_id" [required]="true" [options]="emailTemplates" [filter]="true" [filterBy]="'name'"
              [styleClass]="clicked && addEventForm.controls['email_template_id'].errors ? 'error' : ''" appendTo="body" #emailTemplateEl
              [panelStyle]="{
                  'min-width': emailTemplateEl.el.nativeElement.offsetWidth + 'px',
                  'max-width': emailTemplateEl.el.nativeElement.offsetWidth + 'px'
              }"
              class="form-dropdown email_template_id">
            </p-select>
          </div>
          <app-handle-error [clicked]="clicked" [control]="addEventForm.get('email_template_id')" name="Email template">
          </app-handle-error>
        </div>

        <div class="form-group neo-input-wrapper">
          <div class="proctoring-toggle-row">
            <div class="proctoring-toggle-text">
              <span class="proctoring-toggle-label">Enable proctoring</span>
            </div>
            <p-toggleswitch inputId="add-event-proctoring" formControlName="enableProctoring"></p-toggleswitch>
          </div>

          @if (addEventForm.controls['enableProctoring'].value) {
          <div class="proctoring-settings">
            <!-- Each proctoring capability is its own titled block; add future ones below. -->
            <div class="proctoring-feature">
              <span class="proctoring-feature-title">Face verification <span class="proctoring-feature-suffix">— For Assessment Stage</span></span>
              <small class="proctoring-feature-hint">How the candidate's photo is captured during registration.</small>
              <div class="proctoring-mode-list">
                <label class="proctoring-mode-item">
                  <p-radioButton name="photoCaptureMode" value="upload" formControlName="photoCaptureMode"></p-radioButton>
                  <span>Upload image</span>
                </label>
                <label class="proctoring-mode-item">
                  <p-radioButton name="photoCaptureMode" value="live" formControlName="photoCaptureMode"></p-radioButton>
                  <span>Live capture</span>
                </label>
                <label class="proctoring-mode-item">
                  <p-radioButton name="photoCaptureMode" value="both" formControlName="photoCaptureMode"></p-radioButton>
                  <span>Both</span>
                </label>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </form>
  </div>

  <!-- Footer -->
  <div class="form-footer">
    <button type="button" 
      class="cancel-btn" 
      (click)="onCancel()">
      Cancel
    </button>
    <button pButton pRipple type="submit"
      (click)="inEditMode ? updateEvent(addEventForm) : publishEvent(addEventForm)"
      [label]="inEditMode ? 'Save' : 'Publish'" 
      [loading]="publishBtnLoading"
      [disabled]="publishBtnLoading"
      class="save-btn">
    </button>
  </div>
</div>

<p-toast></p-toast>